(function(){
  const qs = (s, root = document) => root.querySelector(s);
  const qsa = (s, root = document) => Array.from(root.querySelectorAll(s));
  const exists = el => !!el;
  const normalizeVariantName = name => (name||'').replace(/\s*-\s*/g, '-').replace(/\s+/g,' ').trim().toLowerCase();

  const sizeTabAnchor = qs('.size-tabs a');
  if (sizeTabAnchor) {
    sizeTabAnchor.addEventListener('click', (event) => {
      event.preventDefault();
      const href = event.target.getAttribute('href');
      const targetSection = href ? qs(href) : null;
      targetSection?.scrollIntoView({ behavior: 'smooth' });
    });
  }

  const sizeChartRoot = qs('[js-pdp-size-chart-popup]');
  if (!sizeChartRoot) return;
  const tableSizeChartContainers = qsa('.size-radio', sizeChartRoot).map(el => el.closest('tr')).filter(Boolean);
  const sizeChartFormVariants = qsa('.product-form__input_wrap input[name="Size"]', sizeChartRoot);
  const sizeChartStitchedVariants = qsa('[js-stiched-option-name] input[name="Stitched"]', sizeChartRoot);
  const submitPopupButton = document.getElementById('submit-popup');
  const inchBtn = qs('[js-size-convert-btn-inch]', sizeChartRoot) || qs('[js-size-convert-btn-inch]');
  const cmBtn = qs('[js-size-convert-btn-cm]', sizeChartRoot) || qs('[js-size-convert-btn-cm]');
  const convertibleCells = qsa('.convertible', sizeChartRoot);
  const inchToCm = 2.54;

  let isEventFromCode = false;
  const updateSubmitPopupButtonState = () => {
    if (!submitPopupButton) return;
    const selectedValue = qs('.product-form__input_wrap input[name="Size"]:checked', sizeChartRoot);
    if (selectedValue) {
      submitPopupButton.disabled = false;
      if (!isEventFromCode) {
        isEventFromCode = true;
        const mainProductVariant = qs(`.product-custom .main-grid input[name="Size"][value="${CSS.escape(selectedValue.value)}"]`);
        if (mainProductVariant && !mainProductVariant.checked) {
          mainProductVariant.checked = true;
          mainProductVariant.dispatchEvent(new Event('change', { bubbles: true }));
          qs(`label[for="${mainProductVariant.id}"]`)?.click();
        }
        isEventFromCode = false;
      }
    } else {
      submitPopupButton.disabled = true;
    }
  };

  const convertToCm = () => convertibleCells.forEach(cell => {
    const inch = parseFloat(cell.getAttribute('data-inch'));
    if (!isNaN(inch)) cell.textContent = (inch * inchToCm).toFixed(2);
  });
  const convertToInches = () => convertibleCells.forEach(cell => {
    cell.textContent = cell.getAttribute('data-inch');
  });
  if (inchBtn) inchBtn.addEventListener('click', () => !inchBtn.classList.contains('active') && convertToInches());
  if (cmBtn) cmBtn.addEventListener('click', () => !cmBtn.classList.contains('active') && convertToCm());

  const anyRowHasIndia = tableSizeChartContainers.some(tr => !!tr.querySelector('[data-india-size]'));
  const isIndiaTable = anyRowHasIndia;

  const clickVariantLabelByFormInput = (formInput) => {
    if (!formInput) return;
    const label = document.querySelector(`label[for="${formInput.id}"]`);
    if (label) label.dispatchEvent(new Event('click', { bubbles: true }));
    else formInput.dispatchEvent(new Event('change', { bubbles: true }));
  };

  const allowedIndiaSizes = ['xs','s','m','l','xl','2xl','xxl','3xl','xxxl'];

  const handleSelection = (selectedVariantValue) => {
    const normalizedSelected = normalizeVariantName(selectedVariantValue);

    tableSizeChartContainers.forEach(tr => {
      const tableRadio = tr.querySelector('input[name="sizeTable"]');
      if (!tableRadio) return;
      const tableValueNorm = normalizeVariantName(tableRadio.value);
      const isSelected = tableValueNorm === normalizedSelected;
      tableRadio.checked = isSelected;
      tr.classList.toggle('selected', isSelected);
    });

    if (isIndiaTable) {
      const selectedRow = tableSizeChartContainers.find(tr => {
        const radio = tr.querySelector('input[name="sizeTable"]');
        return radio && normalizeVariantName(radio.value) === normalizedSelected;
      });
      if (selectedRow) {
        const indiaSize = selectedRow.querySelector('[data-india-size]')?.dataset.indiaSize || '';
        const normalizedIndiaSize = normalizeVariantName(indiaSize);
        if (normalizedIndiaSize) {
          const matchingFormVariant = sizeChartFormVariants.find(fi => normalizeVariantName(fi.value) === normalizedIndiaSize);
          if (matchingFormVariant && allowedIndiaSizes.includes(normalizedIndiaSize)) {
            matchingFormVariant.checked = true;
            clickVariantLabelByFormInput(matchingFormVariant);
            matchingFormVariant.dispatchEvent(new Event('change', { bubbles: true }));
            selectedRow.classList.add('selected');
          }
        }
      }
    } else {
      const matchingFormVariant = sizeChartFormVariants.find(fi => normalizeVariantName(fi.value) === normalizedSelected);
      if (matchingFormVariant) {
        matchingFormVariant.checked = true;
        clickVariantLabelByFormInput(matchingFormVariant);
        matchingFormVariant.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    sizeChartFormVariants.forEach(sizeChartVariant => {
      if (normalizeVariantName(sizeChartVariant.value) === normalizedSelected) {
        sizeChartVariant.checked = true;
        sizeChartVariant.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });

    updateSubmitPopupButtonState();
  };

  tableSizeChartContainers.forEach(tr => {
    const tableRadio = tr.querySelector('input[name="sizeTable"]');
    if (!tableRadio) return;
    tableRadio.addEventListener('click', () => handleSelection(normalizeVariantName(tableRadio.value)));
  });

  sizeChartFormVariants.forEach(variant => {
    variant.addEventListener('click', () => {
      handleSelection(normalizeVariantName(variant.value));
    });
  });

  const updateTableForIndia = () => {
    const sizeCountMap = {};
    tableSizeChartContainers.forEach(tr => {
      const radio = tr.querySelector('input[name="sizeTable"]');
      if (!radio) return;
      const parentIndia = tr.querySelector('[data-india-size]');
      const indiaSize = parentIndia?.dataset.indiaSize;
      if (!indiaSize) {
        tr.classList.add('hide');
        return;
      }
      const normalizedIndiaSize = normalizeVariantName(indiaSize);
      const isFirstSet = ['xs','s','m'].includes(normalizedIndiaSize);
      const correspondingFormVariant = sizeChartFormVariants.find(fi => normalizeVariantName(fi.value) === normalizedIndiaSize);
      if (!!correspondingFormVariant) {
        sizeCountMap[normalizedIndiaSize] = (sizeCountMap[normalizedIndiaSize] || 0) + 1;
        const currentCount = sizeCountMap[normalizedIndiaSize];
        if ((isFirstSet && currentCount === 1) || (!isFirstSet && currentCount > 1)) {
          tr.classList.add('hide');
          return;
        }
        tr.classList.remove('hide');
        if (correspondingFormVariant.disabled || correspondingFormVariant.classList.contains('disabled')) {
          tr.classList.add('disabled');
        } else {
          tr.classList.remove('disabled');
        }
        const formVariantParent = correspondingFormVariant.closest('.product-form__input_wrap');
        if (formVariantParent?.classList.contains('hidden')) tr.classList.add('hide');
      } else {
        tr.classList.add('hide');
      }
    });
  };

  const updateTableForUS = () => {
    tableSizeChartContainers.forEach(tr => {
      const radio = tr.querySelector('input[name="sizeTable"]');
      if (!radio) return;
      const correspondingFormVariant = sizeChartFormVariants.find(fi => normalizeVariantName(fi.value) === normalizeVariantName(radio.value));
      const formVariantParent = correspondingFormVariant?.closest('.product-form__input_wrap');
      if (!correspondingFormVariant) {
        tr.classList.add('hide');
      } else {
        tr.classList.remove('hide');
        if (correspondingFormVariant.disabled || correspondingFormVariant.classList.contains('disabled')) {
          tr.classList.add('disabled');
        } else {
          tr.classList.remove('disabled');
        }
        if (formVariantParent?.classList.contains('hidden')) tr.classList.add('hide');
        else tr.classList.remove('hide');
      }
    });
  };

  const updateTableSizeChartContainers = () => {
    if (isIndiaTable) updateTableForIndia();
    else updateTableForUS();
  };

  if (!isIndiaTable && sizeChartStitchedVariants.length) {
    sizeChartStitchedVariants.forEach(st => {
      st.addEventListener('change', () => setTimeout(updateTableSizeChartContainers, 200));
    });
  }

  updateTableSizeChartContainers();

  qsa('.product-custom .main-grid input[name="Size"]').forEach(mainProductVariant => {
    mainProductVariant.addEventListener('change', () => {
      if (!mainProductVariant.checked) return;
      const selectedValue = normalizeVariantName(mainProductVariant.value);

      sizeChartFormVariants.forEach(sizeChartVariant => {
        if (normalizeVariantName(sizeChartVariant.value) === selectedValue) {
          sizeChartVariant.checked = true;
          sizeChartVariant.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });

      tableSizeChartContainers.forEach(tr => {
        const tableVariant = tr.querySelector('input[name="sizeTable"]');
        if (!tableVariant) return;
        const tableVariantValue = normalizeVariantName(tableVariant.value);
        tr.classList.toggle('selected', tableVariantValue === selectedValue);

        if (isIndiaTable) {
          const indiaSize = tr.querySelector('[data-india-size]')?.dataset.indiaSize || '';
          const normalizedIndiaSize = normalizeVariantName(indiaSize);
          if (normalizedIndiaSize === selectedValue) {
            tableVariant.checked = true;
            tableVariant.dispatchEvent(new Event('change', { bubbles: true }));
            if (allowedIndiaSizes.includes(normalizedIndiaSize)) tr.classList.add('selected');
            else tr.classList.remove('selected');
          }
        } else {
          if (tableVariantValue === selectedValue) {
            tableVariant.checked = true;
            tableVariant.dispatchEvent(new Event('change', { bubbles: true }));
            tr.classList.add('selected');
          } else {
            tr.classList.remove('selected');
          }
        }
      });

      updateSubmitPopupButtonState();
    });
  });

  updateSubmitPopupButtonState();

  sizeChartFormVariants.forEach(fi => {
    fi.addEventListener('change', () => {
      updateSubmitPopupButtonState();
    });
  });

  const initializeFromChecked = () => {
    const checked = qs('.product-form__input_wrap input[name="Size"]:checked', sizeChartRoot);
    if (checked) {
      handleSelection(normalizeVariantName(checked.value));
    } else {
      const mainChecked = qs('.product-custom .main-grid input[name="Size"]:checked');
      if (mainChecked) handleSelection(normalizeVariantName(mainChecked.value));
    }
  };
  initializeFromChecked();
})();
